import EditStore from './containers/EditStore';
import reducer from './services/reducer';
import { EditStoreState, editStoreSelectors } from './services/selectors';
import epics from './services/epics';

export default EditStore;

export { reducer, EditStoreState, editStoreSelectors, epics };



// WEBPACK FOOTER //
// ./src/scenes/EditStore/index.ts